<ng-container *ngIf="merged | async as interest; else loading">
  <div class="mt-3 animated fadeIn" role="region" aria-label="Interests and Expertise">
    <h4>Interests and Expertise</h4>

    <ng-container *ngIf="interest.teaching?.length > 0 || interest.teachingExpertise?.length > 0">
      <h5>Teaching</h5>
      <div *ngIf="interest.teaching?.length > 0" [innerHTML]="decode(interest.teaching) | safeHtml"></div>
      <div *ngIf="interest.teachingExpertise?.length > 0" [innerHTML]="decode(interest.teachingExpertise) | safeHtml"></div>
    </ng-container>

    <ng-container *ngIf="interest.research?.length > 0 || interest.researchExpertise?.length > 0">
      <h5 class="mt-3">Research</h5>
      <div *ngIf="interest.research?.length > 0" [innerHTML]="decode(interest.research) | safeHtml"></div>
      <div *ngIf="interest.researchExpertise?.length > 0" [innerHTML]="decode(interest.researchExpertise) | safeHtml"></div>
    </ng-container>

    <ng-container *ngIf="interest.service?.length > 0 || interest.serviceExpertise?.length > 0">
      <h5 class="mt-3">Service</h5>
      <div *ngIf="interest.service?.length > 0" [innerHTML]="decode(interest.service) | safeHtml"></div>
      <div *ngIf="interest.serviceExpertise?.length > 0" [innerHTML]="decode(interest.serviceExpertise) | safeHtml"></div>
    </ng-container>

    <ng-container *ngIf="interest.clinical?.length > 0 || interest.clinicalExpertise?.length > 0">
      <h5 class="mt-3">Clinical</h5>
      <div *ngIf="interest.clinical?.length > 0" [innerHTML]="decode(interest.clinical) | safeHtml"></div>
      <div *ngIf="interest.clinicalExpertise?.length > 0" [innerHTML]="decode(interest.clinicalExpertise) | safeHtml"></div>
    </ng-container>

  </div>
</ng-container>

<ng-template #loading>
  <div class="mt-3"></div>
  <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
</ng-template>